import { useEffect, useState } from "react";

export const useDeviceDetect = (userAgent = "") => {
  // 1. 초기값은 userAgent 기반으로 결정 (SSR 대응)
  const isMobileUA =
    userAgent.match(
      /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
    ) != null || userAgent.match(/LG|SAMSUNG|Samsung/i) != null;

  const [device, setDevice] = useState(isMobileUA ? "mobile" : "web");

  // 2. CSR 이후에는 window.innerWidth로 실시간 판단
  useEffect(() => {
    const checkDevice = () => {
      if (typeof window !== "undefined") {
        setDevice(window.innerWidth <= 768 ? "mobile" : "web");
      }
    };

    checkDevice(); // 초기 한 번
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return device;
};
